import "./App.css";
import FullWidthTabs from "./tab-bar";

function App() {
  return <FullWidthTabs></FullWidthTabs>;
}

export default App;
